import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import PostApi from '../../models/src/api/PerplayCommunityApi';
import {
  postResponse,
  setPostItemList,
  setPostUserList,
} from '../../actions/user/postActions';
import {
  POST_CREATE_REQUEST,
  POST_DEPOSIT_REQUEST,
  POST_DETAILS_REQUEST,
  POST_EXCEL_DOWNLOAD,
  POST_ITEM_SEARCH_REQUEST,
  POST_LIST_REQUEST,
  POST_REMOVE_REQUEST,
  POST_USER_SEARCH_REQUEST,
} from '../../constants/user/postConstants';
import {
  CommunityControllerDtoPostAccountSearchRequest, CommunityControllerDtoPostDepositRequest,
  CommunityControllerDtoPostDetailRequest, CommunityControllerDtoPostExcelDownloadRequest,
  CommunityControllerDtoPostListRequest, CommunityControllerDtoPostRemoveRequest,
  GameControllerDtoConfigItemListRequest,
} from '../../models/src';
import PerplayGameApi from '../../models/src/api/PerplayGameApi';
import BaseResponse from '../../models/src/model/BaseResponse';
import CommunityControllerDtoPostListResponse from '../../models/src/model/CommunityControllerDtoPostListResponse';
import CommunityControllerDtoPostDetailResponse from '../../models/src/model/CommunityControllerDtoPostDetailResponse';
import GameControllerDtoConfigItemListResponse from '../../models/src/model/GameControllerDtoConfigItemListResponse';
import CommunityControllerDtoPostAccountSearchResponse
  from '../../models/src/model/CommunityControllerDtoPostAccountSearchResponse';
import CommunityControllerDtoPostCreateResponse from '../../models/src/model/CommunityControllerDtoPostCreateResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PostApi(config.API_CLIENT);
const itemApi = new PerplayGameApi(config.API_CLIENT);

function* postListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CommunityControllerDtoPostListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.postType = payload.postType;
    requestData.attachedPer = payload.attachedPer;
    requestData.attachedXper = payload.attachedXper;
    requestData.isAttachedItem = payload.isAttachedItem;
    requestData.attachedItem = payload.attachedItem;
    requestData.sentAt = payload.sentAt;
    requestData.expireAt = payload.expireAt;
    requestData.searchString = payload.searchString;
    requestData.itemName = payload.itemName;
    requestData.postNo = payload.postNo;
    requestData.accountNo = payload.accountNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCommunityPostListPost({ communityControllerDtoPostListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CommunityControllerDtoPostListResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* postDetailsRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CommunityControllerDtoPostDetailRequest();
    requestData.postNo = payload.postNo;
    requestData.searchString = payload.searchString;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayCommunityPostDetailPost({ communityControllerDtoPostDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CommunityControllerDtoPostDetailResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* postExcelDownloadSaga(payload) {
  try {
    console.log('CSV 다운로드 요청');
    const requestData = new CommunityControllerDtoPostExcelDownloadRequest();
    requestData.postNo = payload.postNo;
    console.log(requestData);

    const result = yield api.apiPerplayCommunityPostExcelDownloadPost({ communityControllerDtoPostExcelDownloadRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, null);
    console.log('data: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* postItemSearchRequestSaga(payload) {
  try {
    const requestData = new GameControllerDtoConfigItemListRequest();
    requestData.searchString = payload.searchString;
    console.log('requestData: ', requestData);

    const result = yield itemApi.apiPerplayGameConfigItemListPost({ gameControllerDtoConfigItemListRequest: requestData }, () => {});
    const data = itemApi.apiClient.deserialize(result, GameControllerDtoConfigItemListResponse);
    console.log('data: ', data);

    yield put(setPostItemList(data.list));
  } catch (e) {
    console.log(e);
  }
}

function* postUserSearchRequestSaga(payload) {
  try {
    const requestData = new CommunityControllerDtoPostAccountSearchRequest();
    requestData.searchString = payload.searchString;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayCommunityPostAccountSearchPost({ communityControllerDtoPostAccountSearchRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CommunityControllerDtoPostAccountSearchResponse);
    console.log('data: ', data);

    yield put(setPostUserList(data.list));
  } catch (e) {
    console.log(e);
  }
}

function* postCreateRequestSaga(payload) {
  try {
    console.log('우편 생성 요청!');
    const result = yield api.apiPerplayCommunityPostCreatePost(payload, () => {});
    const data = api.apiClient.deserialize(result, CommunityControllerDtoPostCreateResponse);
    console.log('data: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* postDepositRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(postResponse(null, null));

    const requestData = new CommunityControllerDtoPostDepositRequest();
    requestData.postNo = payload.postNo;
    requestData.tokenType = payload.tokenType;
    requestData.transactionHash = payload.transactionHash;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCommunityPostDepositPost({ communityControllerDtoPostDepositRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* postRemoveRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(postResponse(null, null));

    const requestData = new CommunityControllerDtoPostRemoveRequest();
    requestData.postNo = payload.postNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCommunityPostRemovePost({ communityControllerDtoPostRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* postRootSaga() {
  yield all([
    takeEvery(POST_LIST_REQUEST, postListRequestSaga),
    takeEvery(POST_DETAILS_REQUEST, postDetailsRequestSaga),
    takeEvery(POST_EXCEL_DOWNLOAD, postExcelDownloadSaga),
    takeEvery(POST_ITEM_SEARCH_REQUEST, postItemSearchRequestSaga),
    takeEvery(POST_USER_SEARCH_REQUEST, postUserSearchRequestSaga),
    takeEvery(POST_CREATE_REQUEST, postCreateRequestSaga),
    takeEvery(POST_DEPOSIT_REQUEST, postDepositRequestSaga),
    takeEvery(POST_REMOVE_REQUEST, postRemoveRequestSaga),
  ]);
}

const postSagas = [fork(postRootSaga)];

export default postSagas;
